module.exports = __webpack_public_path__ + "cuttingLineBottom.png?48522e9dd21887a6ff41ad015cdc2da4";